// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.name-text[data-v-83b309ac]{\n   font-size: 14px;\n   color: #2F3030;\n   line-height: 28px;\n}\n", ""]);
// Exports
module.exports = exports;
